import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class UserAgent extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): UserAgent {
    return new UserAgent(value);
  }
}
